/**
 * Created by daniel on 01/05/17.
 */

import React, {Component} from 'react';
import {List, ListItem} from "material-ui";
import {yellow500} from "material-ui/styles/colors";

class Hierarchy extends Component {
  render() {
    
    // Build the list items
    let props = this.props;
    function buildListItems(contentItem) {
      return (
        <ListItem
          key={contentItem.contentId}
          primaryText={contentItem.contentName? contentItem.contentName : contentItem.configName}
          secondaryText={
            <div>
              Type: {contentItem.configId}
              <br/>
              ID: {contentItem.contentId}
            </div>
          }
          secondaryTextLines={2}
          open={true}
          //onMouseEnter={() => props.hover(contentItem.contentId)}
          //onMouseLeave={() => props.hover(null)}
          onClick={() => props.selected(contentItem.contentId)}
          nestedItems={contentItem.childItems.map(buildListItems)}
          innerDivStyle={{
            backgroundColor:  props.selectedItem && contentItem.contentId === props.selectedItem.contentId ? yellow500 : "transparent",
            padding: "5px 16px 5px"
          }}
        />
      );
    }
    
    return (
      <div>
        <List>
          {buildListItems(this.props.tree)}
        </List>
      </div>
    );
  }
}

export default Hierarchy;


// WEBPACK FOOTER //
// ./src/App/Editor/components/ui/ToolBox/Hierarchy.js